"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FriendList = void 0;
var solid_ui_1 = require("solid-ui");
var lit_html_1 = require("lit-html");
var style_map_js_1 = require("lit-html/directives/style-map.js");
var baseStyles_1 = require("./baseStyles");
var baseStyles_2 = require("./baseStyles");
var styles = {
    root: (0, style_map_js_1.styleMap)((0, baseStyles_1.padding)()),
    heading: (0, style_map_js_1.styleMap)((0, baseStyles_1.headingLight)()),
    card: (0, style_map_js_1.styleMap)((0, baseStyles_1.card)()),
};
var FriendList = function (profileBasics, subject, context) {
    var nameStyle = (0, style_map_js_1.styleMap)(__assign(__assign({}, (0, baseStyles_2.heading)()), { 
        // "text-decoration": "underline",
        color: profileBasics.highlightColor }));
    if (createList(subject, context)) {
        return (0, lit_html_1.html)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    <div data-testid=\"friend-list\" style=\"", "\">\n      <div style=", ">\n        <h3 style=", ">Friends</h3>\n        ", "\n      </div>\n    </div>\n    "], ["\n    <div data-testid=\"friend-list\" style=\"", "\">\n      <div style=", ">\n        <h3 style=", ">Friends</h3>\n        ", "\n      </div>\n    </div>\n    "])), styles.card, styles.root, nameStyle, createList(subject, context));
    }
    return (0, lit_html_1.html)(templateObject_2 || (templateObject_2 = __makeTemplateObject([""], [""])));
};
exports.FriendList = FriendList;
var createList = function (subject, _a) {
    var dom = _a.dom;
    var target = dom.createElement("div");
    solid_ui_1.widgets.attachmentList(dom, subject, target, {
        doc: subject.doc(),
        modify: false,
        predicate: solid_ui_1.ns.foaf("knows"),
        noun: "friend",
    });
    if (target.textContent === "")
        return null;
    else
        return target;
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=FriendList.js.map